import capacitorGeolocation from "../../mobile/@capacitor/capacitorGeolocation";
import appconfig from "../../appconfig";
import { platformDetector } from "../../mobile/platformDetector";

const options = {
	enableHighAccuracy: true,
	timeout: 1000,
	maximumAge: 0
};
const webGeolocation = ({onSuccess, onError} = {}) => {
	if ("geolocation" in navigator) {
		return new Promise((resolve) => {
			const success = (pos) => {
				onSuccess && onSuccess(pos);
				resolve(pos);
			};
			const error = () => {
				onError && onError();
				resolve();
			};
			navigator.geolocation.getCurrentPosition(success, error, options);
		});
	}
};
const platform = appconfig.mobile.mobileApi().platformId;

const geolocation = Object.freeze({
	checkPermissions: async () => {
		if (platform === "web") {
			if (platformDetector.isIosDevice()) {
				// skip permission check for browsers on ios, because that seems to trigger location dialog prompt...
				return (await navigator.permissions.query({name:"geolocation"})).state;
			}
			if ("permissions" in navigator) {
				return (await navigator.permissions.query({name:"geolocation"})).state;
			}
		} else {
			return capacitorGeolocation.checkPermissions();
		}
	},
	checkPermissionsPolling: async (callback) => {
		const intervalId = setInterval(async () => {
			const status = await geolocation.checkPermissions();
			if (status === "granted") {
				callback && callback();
				clearInterval(intervalId);
			} else {
				// denied or prompt-with-rationale (2nd round of native dialog after first prompt is denied)
				if (status !== "prompt") {
					clearInterval(intervalId);
				}
			}
		}, 100);
	},
	watchPositionSync: () => {
		if (platform === "web") {
			return webGeolocation();
		} else {
			return capacitorGeolocation.watchPosition();
		}
	},
	watchPositionAsync: ({onSuccess, onError}) => {
		if (platform === "web") {
			return webGeolocation({onSuccess, onError});
		} else {
			return capacitorGeolocation.watchPosition({onSuccess, onError});
		}
	},
	watchPositionIosMobileBrowserAsync: ({onSuccess, onError}) => {
		return webGeolocation({onSuccess, onError});
	}
});

export default geolocation;
